import React from 'react';
import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import Sparkline from './Sparkline';

type Props = {
  title: string;
  value: string;
  subtitle?: string;
  deltaPct?: number | null;
  icon?: React.ReactNode;
  trendValues?: number[];
};

function formatDelta(deltaPct: number) {
  const sign = deltaPct > 0 ? '+' : '';
  return `${sign}${deltaPct.toFixed(0)}%`;
}

export default function MetricCard({ title, value, subtitle, deltaPct, icon, trendValues }: Props) {
  const deltaColor = deltaPct === null || deltaPct === undefined ? 'default' : deltaPct >= 0 ? 'success' : 'error';
  if (title === 'Calls'){
    console.log('trendValues',title, trendValues);
  }
  
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2.25, '&:last-child': { pb: 2.25 } }}>
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: 0.4, textTransform: 'uppercase' }}>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ mt: 0.75, lineHeight: 1.15 }} noWrap>
              {value}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }} noWrap>
                {subtitle}
              </Typography>
            ) : null}
          </Box>

          <Stack direction="column" alignItems="flex-end" spacing={1}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: 'grey.100',
                display: 'grid',
                placeItems: 'center',
                border: (t) => `1px solid ${t.palette.divider}`,
              }}
            >
              {icon}
            </Box>
            {typeof deltaPct === 'number' ? <Chip size="small" color={deltaColor as any} label={formatDelta(deltaPct)} sx={{ fontWeight: 700 }} /> : <Box sx={{ height: 24 }} />}
          </Stack>
        </Stack>

        {trendValues && trendValues.length > 1 ? (
          <Box sx={{ mt: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
            <Sparkline values={trendValues} />
          </Box>
        ) : null}
      </CardContent>
    </Card>
  );
}

